import { createBrowserRouter } from "react-router-dom";
import { getAppBasePath } from "src/infrastructure/auth";
import { modules } from "src/app/modules";
import { buildAppRoutes } from "src/app/routes";
import { makeReturnAfterSignIn } from "src/app/signInReturn";

/** Data router (overview.md D4); the route table is built in ./routes.tsx. */
export const router = createBrowserRouter(buildAppRoutes(modules), {
  basename: getAppBasePath(),
});

/** Passed to AuthProvider: returns to the page sign-in started from, through this router. */
export const returnAfterSignIn = makeReturnAfterSignIn(
  (to, options) => router.navigate(to, options),
  getAppBasePath()
);
